import { render, staticRenderFns } from "./accountEdit.vue?vue&type=template&id=2997990a"
import script from "./accountEdit.vue?vue&type=script&lang=ts"
export * from "./accountEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports